
import Component, { mixins } from "vue-class-component";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import { ProxyTableData } from '@/UI/components/Helpers/ProxyTableData';
import { SalaryCalculationsTable } from "@/UI/pages/SalaryСalculations/lib/table"
import { SalaryCalculationsTabs } from "@/UI/pages/SalaryСalculations/lib/tabs"
import { Vue } from "vue-property-decorator";
import { RouterNameEnum } from "@/router/router.types";

@Component({
    components: {
        PageTitle,
        BaseDataForm,
    }
})

export default class CosmetologCard extends mixins (
    ProxyTableData,
    SalaryCalculationsTable,
    SalaryCalculationsTabs
) {

    tab: number = 0
    defaultActive: number = 1
    data_workers: any = []

    goToNewRule() {
        Vue.router.push({
            name: RouterNameEnum.CreateNewRule,
            params: {
                id: '1'
            }
        })
    }
    goToNewCriteria() {
        Vue.router.push({
            name: RouterNameEnum.CreateNewCriteria,
            params: {
                id: '1'
            }
        })
    }

    tabChanged(key: number) {
        this.defaultActive = key
        this.tab = key
    }

    addData() {
        this.data_workers.push(
            {
                data1: '',
                data2: ''
            }
        )
    }

    deleteData(index: any) {
        this.data_workers.splice(index, 1)
    }

    async created() {
        this.formReady = true
    }

}
